export default __webpack_public_path__ + "82b499a595f1cb454211e5b384e32010.png";